import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5p3hx22es9: FaireBrandEntity = {
  token: "b_5p3hx22es9",
  type: "brand",
  name: "Melati Drinks",
  avatarUrl:
    "https://cdn.faire.com/fastly/fd0e6a4e83da9863dfc489a5a24fe6ed6861ecc30f3412ec7329ccaed590dc73.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/64e67fb33250de2c86fcc2dfe60aee2c6078f88e3d3dd29f2d07a261017c85c9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fd0e6a4e83da9863dfc489a5a24fe6ed6861ecc30f3412ec7329ccaed590dc73.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/64e67fb33250de2c86fcc2dfe60aee2c6078f88e3d3dd29f2d07a261017c85c9.jpeg",
  location: "Singapore, SGP",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 7,
  isInsider: false,
  description:
    "Our heritage starts in the Javanese Royal Court of the Majapahit Empire in 1293. Botanical tonic drinks were drunk behind palace walls, keeping royalty full of vigor and vitality. These revered recipes were written on palm leaf manuscripts and handed down for centuries over many generations.\n \nMelati is deliciously complex, herbaceous and aromatic. Crafted alongside an ayurvedic specialist, each restorative Asian botanical is treated up to 6 weeks using a traditional cold-extraction process for maximum functionality. \n\nBlended and bottled in Singapore, Melati Drinks celebrates the rich, storied history of ancient herbal remedies from the Far East.\n\nAll the experience, none of the booze\n\nCheers to your health!\n\nOur candles are a social enterprise with 60% of revenue going directly towards women in Indonesia (the other 40% is shipping and packaging costs). Crafted with 100% organic soy wax, pure essential oils, organic cotton wicks and designed to pair well with drinks and food. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:48.655Z",
    importedBy: "entity-db-cli",
  },
};
